import shieldIcon from '@assets/icons/onboarding/v2/shield-dark.svg';
import aiIcon from '@assets/icons/v2/webapp/AI.svg';
import check_icon from '@assets/icons/v2/webapp/photolab/quiz/check_circle_micro.svg';
import closeIcon from '@assets/icons/v2/webapp/photolab/restorations/Back.svg';
import face_scan_image from '@assets/images/ethnicity-quiz/selfieImage.webp';
import bgBiorhythm from '@assets/images/home/background/bgBiorhythm.webp';
import bgDailyHoroscope from '@assets/images/home/background/bgDailyHoroscope.webp';
import bgMyEthnicity from '@assets/images/home/background/bgMyEthnicity.webp';
import bgPopulation from '@assets/images/home/background/bgPopulation.webp';
import biorhythm from '@assets/images/home/biorhythm.png';
import dailyHoroscope from '@assets/images/home/dailyHoroscope.png';
import myEthnicity from '@assets/images/home/myEthnicity.png';
import population from '@assets/images/home/population.png';
import processingImage from '@assets/images/onboarding/camera/processing.webp';
import selfieImage from '@assets/images/onboarding/camera/selfie.webp';
import logoImage from '@assets/images/onboarding/logo.webp';
import ai_icon from '@assets/images/onboarding/startPage/ai_icon.svg';
import dark_part_background from '@assets/images/onboarding/startPage/dark_part_background.webp';
import discover_the_details_of_your_origin_background from '@assets/images/onboarding/startPage/discover_the_details_of_your_origin_background.webp';
import face_image from '@assets/images/onboarding/startPage/face_image.webp';
import how_would_you_look_across_cultures_image from '@assets/images/onboarding/startPage/how_would_you_look_across_cultures_image.webp';
import icon_1 from '@assets/images/onboarding/startPage/icon_1.svg';
import icon_2 from '@assets/images/onboarding/startPage/icon_2.svg';
import icon_3 from '@assets/images/onboarding/startPage/icon_3.svg';
import intro_image from '@assets/images/onboarding/startPage/intro_image_updated.webp';
import logo_minimized from '@assets/images/onboarding/startPage/logo_minimized.webp';
import map_image from '@assets/images/onboarding/startPage/map.webp';
import people_image from '@assets/images/onboarding/startPage/people_image.webp';
import bgImage from '@assets/images/onboarding/subscription/bgImage.webp';
import bgTrust from '@assets/images/onboarding/subscription/bgTrust.webp';
import afterImage from '@assets/images/photolab/after.webp';
import animateAPhotoImage from '@assets/images/photolab/animate-a-photo-image.webp';
import beforeImage from '@assets/images/photolab/before.webp';
import bringPortraits1Image from '@assets/images/photolab/bring-portraits.webp';
import header1Image from '@assets/images/photolab/header_1.webp';
import header2Image from '@assets/images/photolab/header_2.webp';
import ancestryImage from '@assets/images/photolab/quiz/ancestryImage.webp';
import bannerImage from '@assets/images/photolab/quiz/bannerImage.webp';
import billionsImage from '@assets/images/photolab/quiz/billionsImage.webp';
import bringPortraitsImage from '@assets/images/photolab/quiz/bringPortraitImage.webp';
import familyTreeImage from '@assets/images/photolab/quiz/familyTreeImage.webp';
import gradientImage from '@assets/images/photolab/quiz/gradient_background.webp';
import peopleImage from '@assets/images/photolab/quiz/peopleImage.webp';
import bringPortraitsImageAfter from '@assets/images/photolab/recovery/after.webp';
import bringPortraits3Image from '@assets/images/photolab/recovery/before.webp';
import restorationGradient from '@assets/images/photolab/restoration-gradient.webp';
import restoreOldPhotosImage from '@assets/images/photolab/restore-old-photos.webp';
import ethnicity_report_icon_3d from '@assets/images/webapp/offers/ethnicity_report_icon_3d.webp';
import finalizing_your_report_tip_1 from '@assets/images/webapp/offers/finalizing_your_report_tip_1.webp';
import finalizing_your_report_tip_2 from '@assets/images/webapp/offers/finalizing_your_report_tip_2.webp';
import finalizing_your_report_tip_3 from '@assets/images/webapp/offers/finalizing_your_report_tip_3.webp';
import offers_icon_1 from '@assets/images/webapp/offers/icons/icon_1.svg';
import offers_icon_2 from '@assets/images/webapp/offers/icons/icon_2.svg';
import offers_icon_3 from '@assets/images/webapp/offers/icons/icon_3.svg';
import icon_4 from '@assets/images/webapp/offers/icons/icon_4.svg';
import icon_5 from '@assets/images/webapp/offers/icons/icon_5.svg';
import icon_6 from '@assets/images/webapp/offers/icons/icon_6.svg';
import icon_7 from '@assets/images/webapp/offers/icons/icon_7.svg';
import icon_8 from '@assets/images/webapp/offers/icons/icon_8.svg';
import icon_9 from '@assets/images/webapp/offers/icons/icon_9.svg';
import inheritance_report_icon_3d from '@assets/images/webapp/offers/inheritance_report_icon_3d.webp';
import population_report_icon_3d from '@assets/images/webapp/offers/population_report_icon_3d.webp';
import header3Video from '@assets/videos/social_thumper_280х376.mp4';
import bringPortraitsVideo from '@assets/videos/social_thumper_368х512.mp4';
import videoAnimateAPhoto from '@assets/videos/social_thumper_632x500.mp4';

export const IMAGE_PATHS = [
  'img/logo.webp',
  'img/signin/back_image.webp',
  'img/Ava_01.webp',
  'img/Ava_02.webp',
  'img/Ava_03.webp',
  bgBiorhythm,
  bgDailyHoroscope,
  bgMyEthnicity,
  bgPopulation,
  biorhythm,
  dailyHoroscope,
  myEthnicity,
  population,
  processingImage,
  'images/avatar1.jpg',
  'images/avatar2.webp',
  'images/avatar3.png',
  selfieImage,
  logoImage,
  'img/logo_minimized.webp',
  'img/offers/addPacks/image_1.webp',
  'img/offers/addPacks/image_2.webp',
  'img/offers/addPacks/image_3.webp',
  'img/offers/addPacks/image_4.webp',
  'img/offers/addPacks/earth_huge.webp',
  'img/offers/addPacks/dna_huge.webp',
  bgImage,
  bgTrust,
  'img/offers/offers_checkmark.svg',
  'img/offers/offers_questionmark.svg',
  'img/offers/addPacks/svg1.svg',
  'img/offers/addPacks/svg2.svg',
  'img/offers/addPacks/svg3.svg',
  'img/offers/addPacks/svg4.svg',
  'img/offers/addPacks/svg5.svg',
  'img/offers/addPacks/svg6.svg',
  'img/offers/addPacks/svg7.svg',
  logo_minimized,
  ai_icon,
  dark_part_background,
  discover_the_details_of_your_origin_background,
  face_image,
  how_would_you_look_across_cultures_image,
  icon_1,
  icon_2,
  icon_3,
  intro_image,
  face_scan_image,
  map_image,
  people_image,
  'img/photolab-quiz/ready-photo.webp',
  'videos/social_thumper_330х460.mp4',
  header1Image,
  header2Image,
  header3Video,
  shieldIcon,
  check_icon,
  ai_icon,
  ancestryImage,
  bannerImage,
  billionsImage,
  bringPortraitsImage,
  familyTreeImage,
  gradientImage,
  peopleImage,
  bringPortraitsVideo,
  'img/photolab-quiz/before.webp',
  'img/photolab-quiz/after.webp',
  'img/photolab-quiz/slide3Image.webp',
  'videos/social_thumper_432x604.mp4',
  beforeImage,
  afterImage,
  bringPortraits1Image,
  restoreOldPhotosImage,
  restorationGradient,
  bringPortraitsVideo,
  bringPortraits3Image,
  bringPortraitsImageAfter,
  aiIcon,
  closeIcon,
];

export const WEB_APP_IMAGE_PATHS = [
  finalizing_your_report_tip_1,
  finalizing_your_report_tip_2,
  finalizing_your_report_tip_3,
  inheritance_report_icon_3d,
  population_report_icon_3d,
  ethnicity_report_icon_3d,
  offers_icon_1,
  offers_icon_2,
  offers_icon_3,
  icon_4,
  icon_5,
  icon_6,
  icon_7,
  icon_8,
  icon_9,
  animateAPhotoImage,
  header1Image,
  header2Image,
  header3Video,
  bringPortraitsImage,
  bringPortraits1Image,
  videoAnimateAPhoto,
  beforeImage,
  afterImage,
];
